export default {
  id: 248,
  title: 'Target #248 - Bolt',
  url: 'https://cssbattle.dev/play/248',
  colors: ['#FFFFFF', '#444444'],
  solution:
    '<p a><p b><p c><style>body,p[a],p[c]{background:#fff}p{position:fixed;margin:0}p[a]{top:25;left:75;width:210;height:210;border:20px solid #444;border-radius:9in}p[b]{top:65;left:130;width:140;height:170;background:conic-gradient(from 35deg at 70px 170px,transparent 290deg,#444 290deg);border-radius:9in 9in 0 0}p[c]{top:135;left:130;width:50;height:20;box-shadow:0 30px #fff,0 60px #fff,90px 0 #fff,90px 30px #fff,90px 60px #fff',
}
